var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.36606 19C16.0813 19 20.8502 11.6844 20.8502 5.35098C20.8502 5.14517 20.8502 4.93936 20.841 4.73355C21.7652 4.05063 22.5692 3.20868 23.2069 2.25446C22.3382 2.63802 21.4232 2.89996 20.4805 3.01222C21.4694 2.4135 22.2088 1.46864 22.56 0.355387C21.6265 0.91669 20.6099 1.3096 19.5471 1.51541C17.7541 -0.421082 14.7505 -0.514633 12.8373 1.3096C11.6082 2.47898 11.0814 4.22838 11.4695 5.89358C7.67104 5.69712 4.11286 3.87289 1.70992 0.879269C0.453004 3.06835 1.09071 5.87487 3.17941 7.27812C2.42156 7.25941 1.69144 7.0536 1.02601 6.6794C1.02601 6.69811 1.02601 6.71682 1.02601 6.73553C1.02601 9.01816 2.61564 10.9827 4.83374 11.4411C4.13134 11.6376 3.40122 11.6656 2.68958 11.5253C3.3088 13.4805 5.09251 14.8183 7.11652 14.8557C5.43447 16.1935 3.36425 16.9138 1.22934 16.9138C0.850413 16.9138 0.471489 16.8858 0.101807 16.8483C2.27369 18.261 4.78752 19 7.36606 19Z","fillOpacity":"0.64"}));
}

Twitter.defaultProps = {"width":"24","height":"19","viewBox":"0 0 24 19","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;



//////////////////
// WEBPACK FOOTER
// ./~/svg-react-loader/lib/loader.js!./src/images/twitter.svg
// module id = 433
// module chunks = 114276838955818